/**
 * Path of the file an in-flight `edit_file` tool call is modifying, or null.
 *
 * `edit_file` input is diff-shaped (oldString/newString), so unlike
 * `write_file` there is no full content to stream into the code viewer — but
 * the user still needs to see WHICH file is being touched. Active means the
 * input is streaming or buffered and no terminal output state has arrived.
 */
export function activeEditedFilePath(parts: readonly unknown[] | undefined): string | null {
  const active = (parts ?? []).find(
    (p: any) =>
      p?.type === 'tool-edit_file' && p?.toolCallId && (p.state === 'input-streaming' || p.state === 'input-available'),
  ) as any;

  const filePath = active?.input?.filePath;

  return typeof filePath === 'string' && filePath.length > 0 ? filePath : null;
}
